// extracted by mini-css-extract-plugin
export default {"container":"PageLoaderError__container-Z2TO","embedded":"PageLoaderError__embedded-oBqn"};